import DataList from "../../../../component/DataList";
import { useHistory } from "react-router-dom";

export default function OrderList() {
  const history = useHistory();
  return (
    <>
      <DataList
        url={"/erp/radOrder/orderListMobile"}
        onClickRow={(item) => {
          history.push(
            `/erp/order/detail/${item.tableName}/${item.uuid}/${item.contractNumber}`
          );
        }}
        descriptions={[
          {
            fieldName: "contractNumber",
            fieldShowName: "批号",
            width: 120,
          },
          {
            fieldName: "dealerId",
            fieldShowName: "客户名称",
            width: 100,
            inputType: 6,
            dictionary: "rad_dealer",
          },
          {
            fieldName: "advisorId",
            fieldShowName: "业务员",
            width: 80,
            inputType: 8,
            dictionary: "base_staff_all",
          },
          {
            fieldName: "orderDate",
            fieldShowName: "交货日期",
            width: 100,
            inputType: 4,
            format: "yyyy-MM-dd",
          },
          {
            fieldName: "remark",
            fieldShowName: "备注",
            width: 300,
          },
        ]}
      />
    </>
  );
}
